<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'bookingModule.bookings' | translate }}

      <i
        class="ms-2 fa fa-question-circle"
        role="button"
        tabindex="0"
        [tooltip]="'courseModule.childBookingTooltip' | translate"
      ></i>
    </h3>

    <div class="col-sm-auto" [canSee]="[accessRights.Bookings_write]">
      <button
        (click)="onOpenCreateBooking()"
        class="btn btn-primary"
        type="button"
      >
        {{ 'general.create' | translate }}
        {{ 'bookingModule.booking' | translate }}
      </button>
    </div>
  </div>

  <!-- Body start -->
  <div class="card-body pt-0">
    <booking-table
      [bulkActions]="[BulkAction.DETACH, BulkAction.DELETE]"
      [showStatus]="true"
      [showPageFooter]="false"
      [showTotal]="false"
      (onBulkAction)="onBulkAction($event, 'booking')"
      [tableData]="bookings$ | async"
      [isLoading]="isLoadingBooking$ | async"
      (onClickRow)="onClickedRow($event)"
      class="card-table d-block"
    ></booking-table>
  </div>
</section>
